import { render } from "./ImpressionsBySlotsChart.vue?vue&type=template&id=6f80601c&scoped=true"
import script from "./ImpressionsBySlotsChart.vue?vue&type=script&lang=js"
export * from "./ImpressionsBySlotsChart.vue?vue&type=script&lang=js"

import "./ImpressionsBySlotsChart.vue?vue&type=style&index=0&id=6f80601c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f80601c"]])

export default __exports__